<template>
  <svg
    class="line-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- 新会话：气泡 + 加号 -->
    <template v-if="name === 'newChat'">
      <path d="M20.5 14.5a2 2 0 0 1-2 2H8.3l-4.8 3.8V5.5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
      <path d="M12 7.4v6" />
      <path d="M9 10.4h6" />
    </template>

    <!-- 工具调用：图片框 + 星芒 -->
    <template v-else-if="name === 'tool'">
      <rect x="3.5" y="5.5" width="13" height="13" rx="2.5" />
      <circle cx="8" cy="9.4" r="1" />
      <path d="M3.5 15.2l3.3-3.3a1.8 1.8 0 0 1 2.5 0l4.2 4.2" />
      <path d="M19.3 2.8l.6 1.7 1.7.6-1.7.6-.6 1.7-.6-1.7-1.7-.6 1.7-.6z" />
    </template>

    <!-- 过程文件：文件夹 -->
    <template v-else-if="name === 'folder'">
      <path d="M3.5 7.2a2 2 0 0 1 2-2h3.4a2 2 0 0 1 1.6.8l1.1 1.5h8.9a2 2 0 0 1 2 2v8.7a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2z" />
    </template>

    <!-- 放大：四角外扩 -->
    <template v-else-if="name === 'expand'">
      <path d="M9.5 4.5h-3a2 2 0 0 0-2 2v3" />
      <path d="M14.5 4.5h3a2 2 0 0 1 2 2v3" />
      <path d="M19.5 14.5v3a2 2 0 0 1-2 2h-3" />
      <path d="M4.5 14.5v3a2 2 0 0 0 2 2h3" />
    </template>

    <!-- 缩小：四角内收 -->
    <template v-else-if="name === 'shrink'">
      <path d="M4.5 9h3a2 2 0 0 0 2-2V4.5" />
      <path d="M19.5 9h-3a2 2 0 0 1-2-2V4.5" />
      <path d="M19.5 15h-3a2 2 0 0 0-2 2v2.5" />
      <path d="M4.5 15h3a2 2 0 0 1 2 2v2.5" />
    </template>

    <!-- 收起：右向箭头 -->
    <template v-else-if="name === 'chevronRight'">
      <path d="M9.5 6l6 6-6 6" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'LineIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    // 24 栅格下的描边宽度：1.5 在 16px 渲染尺寸下约 1px 实线，避免白字变粗
    strokeWidth: {
      type: [Number, String],
      default: 1.5
    }
  }
}
</script>

<style lang="scss" scoped>
.line-icon {
  display: block;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
</style>
